import { useUrlParam } from '#hooks/useUrlParam.ts';

export const ISSUER_URL_FILTER_PARAM = 'filter.issuerURL';

/** The endpoint providers tab's issuer URL filter, kept in the URL so the Users page can link to it. */
export function useIssuerURLFilter() {
  return useUrlParam(ISSUER_URL_FILTER_PARAM);
}
